import 'retry-axios';
import Cookies from 'universal-cookie';
import { createAxiosClient } from '../axiosDefaults';
export function create(_ref, _ref2) {
  let {
    baseUrl: baseURL,
    config,
    axiosConfig
  } = _ref;
  let {
    env
  } = _ref2;
  const axiosInstance = createAxiosClient({
    baseURL,
    withCredentials: true,
    raxConfig: {
      retry: 5
    },
    ...axiosConfig
  }, config);
  axiosInstance.defaults.raxConfig = {
    instance: axiosInstance
  };
  const APIService = {
    post(url, data) {
      return axiosInstance.post(url, data);
    }

  };
  return {
    APIService,
    cookieService: new Cookies(),
    isProd: ['preprod', 'prod'].includes(env)
  };
}